import { cn } from '../../lib/cn';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Chargement"
      className={cn(
        'inline-block size-6 animate-spin rounded-full border-2 border-line border-t-accent',
        className,
      )}
    />
  );
}
